export const integrations = {
  reservation: {
    enabled: false,
    targetUrl: '/tr/qr/',
    iframeUrl: '',
    dateLibrary: 'https://cdn.jsdelivr.net/npm/flatpickr',
    legacyType: 'iframe-srcdoc-custom-html-form',
    note: 'Eski ana sayfadaki rezervasyon arama motoru HTML/JS form olarak geldi; yeni tasarimda ayni form iframe srcDoc ile izole edildi ve HotelRunner arama hedefi korundu.',
  },
  location: {
    enabled: true,
    provider: 'Google Maps',
    directionsUrl: 'https://www.google.com/maps/search/?api=1&query=Modi%20Cafe%20Yalova%20Termal',
    iframeUrl:
      'https://maps.google.com/maps?q=Modi%20Cafe%20Yalova%20Termal&t=m&z=15&output=embed&iwloc=near',
  },
  liveSupport: {
    enabled: false,
    provider: 'Posteria',
    scriptUrl: 'https://posteria.io/canli-destek/widget.js?v=20260211-2',
    widgetId: 'x9fQLngAa2eV7j1tsxZug5q1X3D3_PQ6tYabh0NJ6aiRjFkG9',
    brandId: 'PQ6tYabh0NJ6aiRjFkG9',
    desktopPosition: 'bottom-right',
    mobilePosition: 'middle-right',
  },
  subscribe: {
    enabled: false,
    provider: 'Posteria',
    iframeUrl: 'https://posteria.io/abone-formu/PQ6tYabh0NJ6aiRjFkG9',
    height: 600,
  },
}
